"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
require("./profile.scss");
const common_1 = require("../../../../../utils/common");
const profileBlocks_1 = require("../../../genericComponents/profileBlocks");
const react_redux_1 = require("react-redux");
const expertsSlice_1 = require("../../../../../redux/slices/expertsSlice");
class Profile extends react_1.default.Component {
    componentDidMount() {
        const serviceExpert = common_1.urlPrams("uid");
        if (!serviceExpert)
            window.location.href = '/';
        this.props.getSingleExpert(serviceExpert);
    }
    render() {
        var _a, _b, _c, _d, _e, _f;
        const { expert } = this.props.experts;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement("h3", { className: 'page-title mt-md-10' }, "Profile"),
            react_1.default.createElement(core_1.Box, { id: 'profile-container', className: 'v2-main-container' },
                react_1.default.createElement(core_1.Box, { className: 'user-info-wrapper mb-20' },
                    react_1.default.createElement(profileBlocks_1.UserInfo, { avatar: expert.avatar, name: expert.name, companyName: expert.company_name, serviceName: (_a = expert.mainService) === null || _a === void 0 ? void 0 : _a.name, state: expert.states, occupation: expert.blocks.occupation, social: expert.blocks.social }),
                    react_1.default.createElement(profileBlocks_1.ContactInfo, { contactInfo: expert.contactInfo })),
                expert.bio && react_1.default.createElement(profileBlocks_1.About, { bio: expert.bio, className: 'mb-20' }),
                ((_c = (_b = expert.blocks) === null || _b === void 0 ? void 0 : _b.education) === null || _c === void 0 ? void 0 : _c.length) ?
                    react_1.default.createElement(profileBlocks_1.Education, { education: expert.blocks.education, className: 'mb-20' }) : null,
                ((_e = (_d = expert.blocks) === null || _d === void 0 ? void 0 : _d.certs) === null || _e === void 0 ? void 0 : _e.length) ? react_1.default.createElement(profileBlocks_1.LicencesAndCertificates, { certificates: expert.blocks.certs, className: 'mb-20' }) : null,
                expert.areas.length ? react_1.default.createElement(profileBlocks_1.AreasOfExpertise, { link: 'services', heading: 'Skills', areas: expert.areas, className: 'mb-20' }) : null,
                ((_f = expert === null || expert === void 0 ? void 0 : expert.languages) === null || _f === void 0 ? void 0 : _f.length) ? react_1.default.createElement(profileBlocks_1.Languages, { language: expert.languages, className: 'mb-20' }) : null)));
    }
}
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        experts
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getSingleExpert: (id) => dispatch(expertsSlice_1.getSingleExpert(id))
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Profile);
